angular.module("avant.customer_applications.directives").directive "navCustomerApplication",
  ['$compile', '$templateCache', 'CustomerApplicationService', '$cookies', ($compile, $templateCache, CustomerApplicationService, $cookies) ->
    restrict: "A"
    scope: {}
    templateUrl: "/shared/v3/nav_customer_application.html!clear_personal"
    link: ($scope, element, attributes) ->
      $scope.$on "customer:login", (event, data) ->
        if data
          element.replaceWith($compile($templateCache.get("/shared/v3/nav_customer_application.html!logged_in"))($scope))
    controller: ["$scope", "$attrs", ($scope, $attrs) ->
      $scope.exit = ->
        # clear personal information
        scope = angular.element($("[name='person_first_name']")).scope()
        scope?.clearAll()
        $scope.logout()
      $scope.logout = ->
        window.location = '/logout'
    ]
  ]